import { DEFAULT_THEME, normalizeTheme } from './archonTheme';

/**
 * Apply theme to the document root (data-theme + Bootstrap data-bs-theme).
 * @param {import('./archonTheme').ArchonThemeId | unknown} theme
 */
export function applyTheme(theme) {
  if (typeof document === 'undefined') return normalizeTheme(theme);

  const resolved = normalizeTheme(theme);
  const root = document.documentElement;

  root.dataset.theme = resolved;
  root.dataset.bsTheme = resolved;

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    // eslint-disable-next-line no-restricted-syntax -- browser chrome meta tag, not CSS
    meta.setAttribute('content', resolved === 'dark' ? '#0c192c' : '#f0f4f8');
  }

  return resolved;
}

/** @returns {import('./archonTheme').ArchonThemeId} */
export function readAppliedTheme() {
  if (typeof document === 'undefined') return DEFAULT_THEME;
  return normalizeTheme(document.documentElement.dataset.theme);
}
